import React from "react";
import Modal from "../ui/Modal";
import StoreButtons from "../ui/StoreButtons";
import qrcode from "../../assets/images/bigmall-app-modal/BIGMALL-QR-CODE-300x300.png";
import "../styles/app-download.css";

const BENEFITS = [
  { icon: "ph-truck", title: "Fast delivery", text: "Track every order right from your phone." },
  { icon: "ph-headset", title: "Customer support", text: "Reach our team in a tap." },
  { icon: "ph-gift", title: "Special events", text: "App-only deals and seasonal offers." },
];

/** "Get the app" dialog: benefits and store buttons, with a QR code to scan on larger screens. */
const AppDownloadModal = ({ onClose }) => (
  <Modal isOpen onClose={onClose} size="lg" title="Get the Bigmall app" subtitle="Shop faster and never miss a deal.">
    <div className="app-dl">
      <div className="app-dl__main">
        <ul className="app-dl__benefits">
          {BENEFITS.map(({ icon, title, text }) => (
            <li key={title} className="app-dl__benefit">
              <span className="app-dl__benefit-icon" aria-hidden="true">
                <i className={`ph-fill ${icon}`} />
              </span>
              <span>
                <span className="app-dl__benefit-title">{title}</span>
                <span className="app-dl__benefit-text">{text}</span>
              </span>
            </li>
          ))}
        </ul>

        <StoreButtons />
      </div>

      <div className="app-dl__qr">
        <div className="app-dl__qr-frame">
          <img src={qrcode} alt="QR code to download the Bigmall app" className="ui-qr" />
        </div>
        <p className="app-dl__qr-caption">
          <i className="ph ph-scan" aria-hidden="true" /> Scan to download
        </p>
      </div>
    </div>
  </Modal>
);

export default AppDownloadModal;
